import isEmpty from './isEmpty';
export default function isDataType(str, dataType, countryCode) {
  switch (dataType.toUpperCase()) {
    case 'ENUM':
      return !isEnum(str);
    case 'STRING':
      return !isString(str);
    case 'NUMBER_WITH_SPACES_BRACKETS_HYPHEN':
      return !isNumberWithSpacesBracketsHyphen(str);
    case 'TELEPHONE_REGEX':
      return !isTelephoneRegex(str);
    case 'EMAIL_ID':
      return !isValidEmailId(str);
    case 'BOOLEAN':
      return !isBoolean(str);
    case 'FLOAT':
      return !isFloat(str);
    case 'ALPHANUMERIC':
      return !isalphanumeric(str);
    case 'NUMBER_WITH_HYPHEN':
      return !isNumberWithHyphen(str);
    case 'POSITIVENUMBER':
      return !isPositiveNumber(str);
    case 'IFSC':
      return !isValidIfscCode(str);
    case 'ALPHABETS_SPACES':
      return !isAlphabetsWithSpaces(str);
    case 'ALPHABETS':
      return !isAlphabets(str);
    case 'NON_ALPHANUMERIC_WITH_SPACES':
      return isNotAlphanumericWithSpaces(str);
    case 'PRICING_PLAN_NAME':
      return !isvaildPricingPlanName(str);
    case 'ADDRESS_FIELD_ALLOWED_CHARACTERS':
      return isAllowedAddressField(str);
    case 'DISTRICT_ALLOWED_CHARACTERS':
      return !isDistrictAllowedCharacters(str);
    case 'MSME':
      return !isMSMEAllowedCharaters(str);
    case 'VAT_ID':
      return isValidVatId(str);
    case 'ZIP_CODE':
      return isValidZIPCode(str, countryCode);
    case 'TIN':
      return isValidTin(str);
    default:
      return false;
  }
}

export const regex = {
  IN: {
    name: /^[a-zA-Z\s\d.'\-#@%&/_,]+$/,
    companyName: /^[a-zA-Z\s\d.'\-#+@%&/_,]+$/,
    address: /^[a-zA-Z\s\d.'\-#@%&/_,]+$/
  },
  EU: {
    name: /^[a-zA-Z∂\s\d.'\-#@%&/_,\p{L}]+$/u,
    companyName: /^[\p{L}∂a-zA-Z\s\d.'\-#+@%&/_,]+$/gu,
    address: /^[\p{L}∂a-zA-Z\s\d.'\-#@%&/_,]+$/gu
  },
  NA: {
    name: /^[a-zA-Z\s\d.'\-#@%&/_,]+$/,
    companyName: /^[a-zA-Z\s\d.'\-#+@%&/_,]+$/,
    address: /^[a-zA-Z\s\d.'\-#@%&/_,]+$/
  },
  telephone: /^(?![\s-])[0-9\s-]{5,15}(?<![\s-])$/,
  email: /^[a-zA-Z0-9._+\-']+@[a-zA-Z0-9]+(?:[-.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/,
  integerNumber: /^[1-9]\d*$/,
  wholeNumberUpTo5Decimal: /^\d+(\.\d{1,5})?$/
};

export const countryPincodeValidation = {
  DE: { name: 'Germany', regex: /^\d{5}$/, length: { max: 5 } },
  NL: { name: 'Netherlands', regex: /^[1-9]\d{3}\s[A-Z]{2}$/i, length: { max: 7 } },
  DK: { name: 'Denmark', regex: /^\d{4}$/, length: { max: 4 } },
  SE: { name: 'Sweden', regex: /^[1-9]\d{2}\s\d{2}$/, length: { max: 6 } },
  LU: { name: 'Luxembourg', regex: /^[1-9]\d{3}$/, length: { max: 4 } },
  AT: { name: 'Austria', regex: /^[1-9]\d{3}$/, length: { max: 4 } },
  BE: { name: 'Belgium', regex: /^\d{4}$/, length: { max: 4 } },
  BG: { name: 'Bulgaria', regex: /^[1-9]\d{3}$/, length: { max: 4 } },
  HR: { name: 'Croatia', regex: /^(?:HR-)?\d{5}$/, length: { max: 8 } },
  CY: { name: 'Cyprus', regex: /^[1-9]\d{3}$/, length: { max: 4 } },
  CZ: { name: 'Czechia', regex: /^\d{3}\s\d{2}$/, length: { max: 6 } },
  EE: { name: 'Estonia', regex: /^\d{5}$/, length: { max: 5 } },
  FI: { name: 'Finland', regex: /^\d{5}$/, length: { max: 5 } },
  FR: { name: 'France', regex: /^\d{5}$/, length: { max: 5 } },
  GR: { name: 'Greece', regex: /^[1-9]\d{2}\s?\d{2}$/, length: { max: 6 } },
  HU: { name: 'Hungary', regex: /^[1-9]\d{3}$/, length: { max: 4 } },
  IE: { name: 'Ireland', regex: /^[A-Z][W\d]{2}\s[A-Z\d]{4}$/i, length: { max: 8 } },
  LV: { name: 'Latvia', regex: /^\d{4}$/, length: { max: 4 } },
  LT: { name: 'Lithuania', regex: /^\d{5}$/, length: { max: 5 } },
  MT: { name: 'Malta', regex: /^[A-Z]{3}\s?\d{3}\s?\d$/i, length: { max: 9 } },
  PL: { name: 'Poland', regex: /^\d{2}-\d{3}$/, length: { max: 6 } },
  PT: { name: 'Portugal', regex: /^\d{4}-\d{3}$/, length: { max: 8 } },
  RO: { name: 'Romania', regex: /^\d{6}$/, length: { max: 6 } },
  SK: { name: 'Slovakia', regex: /^\d{3}\s\d{2}$/, length: { max: 6 } },
  SI: { name: 'Slovenia', regex: /^[1-9]\d{3}$/, length: { max: 4 } },
  ES: { name: 'Spain', regex: /^[0-5]\d{4}$/, length: { max: 5 } }
};

function isEnum(str) {
  const expression = /^.*$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

export function isNumberWithSpacesBracketsHyphen(str) {
  const expression = /^([0-9-()\s]*)$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isTelephoneRegex(str) {
  if (!isEmpty(str)) {
    return regex.telephone.test(str);
  } else {
    return false;
  }
}

function isMSMEAllowedCharaters(str) {
  const expression = /^[a-zA-Z\d\s-]+$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isValidVatId(str) {
  const expression = /^(DE)?\d{9}$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isValidZIPCode(str, countryCode) {
  const expression = /^\d{5}-\d{4}$/;
  if (countryCode === 'DE') return str.length === 5;
  else if (countryCode === 'US') return expression.test(str);
}

function isValidEmailId(str) {
  if (!isEmpty(str)) {
    return regex.email.test(str);
  } else {
    return false;
  }
}

function isString(str) {
  const expression = /^([A-Za-z0-9]*)$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isBoolean(str) {
  if (!isEmpty(str)) {
    return (
      str === '0' ||
      str === '1' ||
      str.toLowerCase() === 'true' ||
      str.toLowerCase() === 'false'
    );
  } else {
    return false;
  }
}
export function isFloat(str) {
  const expression = /^\d+(\.\d{1,20})?$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}
export function isalphanumeric(str) {
  const expression = /^[A-Za-z\d\s]+$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

export function isNumberWithHyphen(str) {
  const expression = /^([0-9-]*)$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}
export function isPositiveNumber(str) {
  const expression = /^(\d*)$/;
  if (!isEmpty(str)) {
    return expression.test(str) && str !== '0';
  } else {
    return false;
  }
}

export function isValidIfscCode(str) {
  const expression = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  if (!isEmpty(str)) {
    return expression.test(str) && str !== '0';
  } else {
    return false;
  }
}

function isAlphabetsWithSpaces(str) {
  const expression = /^[a-zA-Z ]*$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isAlphabets(str) {
  const expression = /^[A-Za-z]+$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isDistrictAllowedCharacters(str) {
  const expression = /^[a-zA-Z\d\s().-]*$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isNotAlphanumericWithSpaces(str) {
  const expression = /[^A-Za-z0-9 .-]/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isvaildPricingPlanName(str) {
  const expression = /^[-_,@#&*()[\]{}A-Za-z0-9.\s]*$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isAllowedAddressField(str) {
  const expression = /[{}[\]]/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}

function isValidTin(str) {
  const expression = /^\d{2}-\d{7}$/;
  if (!isEmpty(str)) {
    return expression.test(str);
  } else {
    return false;
  }
}
